import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import MatchDetail from "@/pages/MatchDetail";
import AuthPage from "@/pages/AuthPage";
import Premium from "@/pages/Premium";
import Slips from "@/pages/Slips";
import Wins from "@/pages/Wins";
import AdminWins from "@/pages/AdminWins";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import { AuthProvider } from "@/context/AuthContext";
import RequireAuth from "@/components/RequireAuth";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App dark">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<RequireAuth><Dashboard /></RequireAuth>} />
            <Route path="/match/:id" element={<RequireAuth><MatchDetail /></RequireAuth>} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/premium" element={<Premium />} />
            <Route path="/schedine" element={<Slips />} />
            <Route path="/vincite" element={<Wins />} />
            <Route path="/admin/vincite" element={<AdminWins />} />
            <Route path="/payment/success" element={<RequireAuth premium={false}><PaymentSuccess /></RequireAuth>} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}
